<mat-toolbar class="header-content">
    <div class="header-title">
        <mat-icon>bookmark_add</mat-icon>
        {{ 'resources.save_as_template_title' | translate }}
    </div>

    <lib-button icon="close" color="none" textColor="muted" (click)="cancel()"
        tooltip="{{'viewer.close'|translate}}"></lib-button>
</mat-toolbar>

<mat-dialog-content>
    <ng-container *ngIf="step === 'choice'">
        <p class="hint">{{ 'resources.template_diverged_hint' | translate: { name: appliedTemplateName } }}</p>

        <div class="choice-actions">
            <lib-button color="primary" icon="save" (click)="chooseUpdate()"
                text="{{ 'resources.template_choice_update' | translate: { name: appliedTemplateName } }}"></lib-button>

            <lib-button color="outline" icon="add" (click)="chooseCreate()"
                text="{{ 'resources.template_choice_create' | translate }}"></lib-button>
        </div>
    </ng-container>

    <ng-container *ngIf="step === 'name'">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>{{ 'form.name' | translate }}</mat-label>
            <mat-icon matPrefix>label</mat-icon>
            <input matInput type="text" [(ngModel)]="name" (ngModelChange)="nameError = ''"
                (keydown.enter)="confirmName()" autofocus>
        </mat-form-field>

        <div *ngIf="nameError" class="error-banner">
            <mat-icon fontIcon="error"></mat-icon>
            <span>{{ nameError }}</span>
        </div>

        <div class="button-group">
            <lib-button *ngIf="appliedTemplateName" color="outline" (click)="backToChoice()" icon="arrow_back"
                text="{{ 'form.back' | translate }}"></lib-button>

            <lib-button color="primary" (click)="confirmName()" icon="save"
                text="{{ 'form.save' | translate }}"></lib-button>
        </div>
    </ng-container>
</mat-dialog-content>
